import KpiCard from '../common/KpiCard';
import useMetric from '../../hooks/useMetric';
import { changePct } from '../../utils/format';

export default function ResponseTimeCard() {
  const { status, data, error, retry } = useMetric('responseTime');
  return (
    <KpiCard
      testId="kpi-response-time" title="Avg. Response Time" icon="bi-stopwatch" tone="primary" to="/analytics"
      status={status} error={error} onRetry={retry} emptyText="No response times recorded."
      value={data && `${data.value}${data.unit}`} delta={data && changePct(data.value, data.previous)} lowerIsBetter
      sparkline={data?.sparkline} footnote={data && `90% of replies within ${data.p90}${data.unit}`}
    />
  );
}
